// extracted by mini-css-extract-plugin
export default {"sorterIcon":"Sorter_sorterIcon__W95Zo","gadgetSortedLabel":"Sorter_gadgetSortedLabel__xr6Pt","selectBox":"Sorter_selectBox__1wLLt","selectBoxItem":"Sorter_selectBoxItem__1QF+K"};